import moment from 'moment';
import { RADAR_FORMAT } from '@ro-utils/constant';
moment.locale('pl');

export const getDayForSlider = date => {
  return moment(date, RADAR_FORMAT).calendar(null, {
    sameDay: '[Dzisiaj]',
    nextDay: '[Jutro]',
    lastDay: '[Wczoraj]',
    nextWeek: function() {
      switch (this.day()) {
        case 0:
          return '[W niedzielę]';

        case 2:
          return '[We wtorek]';

        case 3:
          return '[W środę]';

        case 6:
          return '[W sobotę]';

        default:
          return '[W] dddd';
      }
    },
    lastWeek: function() {
      switch (this.day()) {
        case 0:
          return '[W zeszłą niedzielę]';
        case 3:
          return '[W zeszłą środę]';
        case 6:
          return '[W zeszłą sobotę]';
        default:
          return '[W zeszły] dddd';
      }
    },
    sameElse: 'L'
  });
};

export const getHour = date => {
  return moment(date, RADAR_FORMAT).format('HH:mm');
};
